import echarts from 'echarts';
import { getWeekDate, getMonthDate } from '@utils/utils';
export const DateShortcuts = [
  {
    text: '今天',
    value() {
      return [new Date(), new Date()];
    }
  },
  {
    text: '本周',
    value() {
      const { startDate, endDate } = getWeekDate();
      return [startDate, endDate];
    }
  },
  {
    text: '本月',
    value() {
      const { startDate, endDate } = getMonthDate();
      return [startDate, endDate];
    }
  }
];

// 环形饼图
export const getPieOption = (columns = [], rows = []) => {
  let count = 0;
  const [dimensionKey, indicatrixKey] = columns;
  const series = rows.map((item) => {
    count += !isNaN(+item[indicatrixKey]) ? +item[indicatrixKey] : 0;
    return {
      name: item[dimensionKey],
      value: item[indicatrixKey]
    };
  });
  return {
    color: ['#4DDE6D', '#FFD74D', '#01C1B2', '#FF6A00', '#18B1F7'],
    title: [{
      text: count,
      subtext: '（份）',
      top: '39%',
      left: '29%',
      textAlign: 'center',
      textStyle: {
        fontSize: 32,
        fontWeight: 'bold',
        color: '#333333',
        padding: [10, 0]
      },
      subtextStyle: {
        fontSize: 14,
        fontWeight: 'normal',
        color: '#666666',
        padding: [-2, 0]
      }
    }],
    grid: {
      bottom: 150,
      left: 0,
      right: '10%'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      show: true,
      orient: 'vertical',
      top: '26%',
      right: '0%',
      formatter: (name) => {
        const row = series.find(v => v.name === name);
        const newName = name.length > 8 ? name.substr(0, 8) + '...' : name;
        const value = !isNaN((row.value / count) * 100) ? (row.value / count) * 100 : 0;
        return `${newName}（${value.toFixed(0)}%） ${row.value}`;
      },
      textStyle: {
        color: '#333333',
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: 20
      },
      icon: 'circle',
      selectedMode: false
    },
    series: [
      // 主要展示层的
      {
        radius: ['40%', '55%'],
        center: ['30%', '45%'],
        // center: ['center', 'center'],
        type: 'pie',
        label: {
          normal: {
            show: false
          }
        },
        data: series
      }
    ]
  };
};

// 渐变多指标柱状图
export const getBarOptions = (columns = [], rows = []) => {
  const [dimensionKey, ...indicatrixKey] = columns;
  const xAxis = rows.map((v) => v[dimensionKey]);
  const series = indicatrixKey.map((item, index) => {
    const color = index == 1
      ? 'rgba(255, 63, 63'
      : 'rgba(255, 129, 0';
    return {
      name: item,
      type: 'bar',
      barMaxWidth: 40,
      itemStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: `${color},1)`
            },
            {
              offset: 1,
              color: `${color},0.6)`
            }
          ])
        }
      },
      data: rows.map((v) => v[item])
    };
  });
  return {
    grid: {
      top: '17%',
      left: '5%',
      right: '0%',
      bottom: '10%'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    legend: {
      top: '0%',
      left: '9%',
      icon: 'circle',
      itemGap: 24,
      itemWidth: 14,
      itemHeight: 14,
      textStyle: {
        color: '#888888',
        padding: [4, 0, 0, 0],
        fontSize: 13
      },
      data: indicatrixKey
    },
    xAxis: [{
      offset: 8,
      axisLabel: {
        fontSize: 13,
        color: '#444444'
      },
      axisLine: {
        lineStyle: {
          color: '#C4C6CF'
        }
      },
      axisTick: {
        show: false
      },
      data: xAxis
    }],
    yAxis: [{
      name: '单位：元',
      axisLabel: {
        fontSize: 13,
        color: '#444444'
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        lineStyle: {
          color: '#EBECF0'
        }
      },
      nameTextStyle: {
        color: '#888888',
        padding: [0, 0, 15, 0],
        fontSize: 14
      }
    }],
    series: series
  };
};

export const processingData = (allDay, data) => {
  if (!data.length) return [];
  return allDay
    .map(dayItem => {
      const totalRow = data.find(v => dayItem === v.totalDay);
      const refundRow = data.find(v => dayItem === v.refundDay);
      if (totalRow && !refundRow) {
        return Object.assign(totalRow, {
          refundDay: totalRow.totalDay,
          refundAmount: 0
        });
      } else if (refundRow && !totalRow) {
        return Object.assign(refundRow, {
          totalDay: refundRow.refundDay,
          totalAmount: 0
        });
      } else if (refundRow && totalRow) {
        return Object.assign(totalRow, refundRow);
      }
    })
    .filter(item => item);
};
